import React, { memo } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";

function GeneralApplicationInfo() {
  return (
    <Box
      className="application-info"
      sx={{
        maxWidth: 1100,
        mx: "auto",
        px: { xs: 2, sm: 2 },
        py: { xs: 2, sm: 3 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          p: { xs: 2, sm: 2.5 },
        }}
      >
        <Stack spacing={2}>
          {/* Header */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              General Application Information
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Scholarships, bursaries, and awards for graduating students in
              Nanaimo–Ladysmith Public Schools (District 68).
            </Typography>
          </Box>

          <Divider />

          {/* Main Copy */}
          <Stack spacing={1.25}>
            <Typography variant="body2" color="text.primary">
              Thanks to the generosity of our donors, the Nanaimo–Ladysmith
              Schools Foundation (NLSF) is excited to offer a number of
              scholarships, bursaries and awards for graduating students from
              Nanaimo-Ladysmith Public Schools (District 68).
            </Typography>

            <Typography variant="body2">
              The{" "}
              <Box component="span" sx={{ fontWeight: 800 }}>
                GENERAL APPLICATION FORM
              </Box>{" "}
              is your application for{" "}
              <Box component="span" sx={{ fontWeight: 800 }}>
                ALL
              </Box>{" "}
              awards with the exception of those selected by Donors, which
              require additional information and/or documents such as
              transcript, affiliations, life experiences, application form,
              letters or essays.
            </Typography>
          </Stack>

          {/* Eligibility callouts */}
          <Alert severity="info" sx={{ borderRadius: 2 }}>
            Available to graduates of Nanaimo-Ladysmith Public Schools (District
            68) who are Canadian Citizens or hold permanent residency status in
            Canada.
          </Alert>

          <Alert severity="error" sx={{ borderRadius: 2 }}>
            International students, including those on study permits or visas,
            are not eligible to apply.
          </Alert>

          <Divider />

          {/* Steps */}
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 900, mb: 1 }}>
              Steps to Apply
            </Typography>

            <List
              dense
              sx={{
                listStyleType: "decimal",
                pl: 3,
                "& .MuiListItem-root": { display: "list-item", py: 0.25 },
              }}
            >
              <ListItem>
                <ListItemText primary="Create a username and password" />
              </ListItem>

              <ListItem>
                <ListItemText primary="Select which applications you would like to complete — General and/or District/Authority" />
              </ListItem>

              <ListItem>
                <ListItemText primary="Complete your Application Form(s)" />
              </ListItem>

              <ListItem>
                <ListItemText primary="Submit once you are satisfied that your application is complete. It cannot be accessed/edited once submitted." />
              </ListItem>

              <ListItem>
                <ListItemText primary="Print a copy to hand in to your school contact" />
              </ListItem>

              <ListItem>
                <ListItemText
                  primary={
                    <>
                      Apply for{" "}
                      <Link
                        href="/awards-page"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{ fontWeight: 800 }}
                      >
                        Additional Awards
                      </Link>
                    </>
                  }
                />
              </ListItem>
            </List>
          </Box>

          {/* Big emphasis */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              backgroundColor: "#f5f5f5",
              p: 2,
              textAlign: "center",
            }}
          >
            <Typography sx={{ fontWeight: 900 }}>
              YOUR APPLICATION FORM IS YOUR PRESENTATION TO THE COMMITTEE
            </Typography>
            <Typography sx={{ fontWeight: 900, mt: 0.5 }}>
              BE SURE IT REPRESENTS YOU WELL!
            </Typography>
          </Paper>

          <Divider />

          {/* Contact */}
          <Typography variant="body2" color="text.secondary">
            For further information concerning these or other awards, please
            contact the Scholarship contact at your school or NLSF at{" "}
            <Link href="mailto:awards@nlsf.ca" underline="hover">
              awards@nlsf.ca
            </Link>{" "}
            or{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              250-753-4074
            </Box>
            .
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}

export default memo(GeneralApplicationInfo);
